module.exports = __webpack_public_path__ + "img/contact_location.0bee91cd.svg";